export default __webpack_public_path__ + "static/media/regulatory--bicycles-push-button--g2.e86fdf7f.png";